/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import { FEATURE_FLAGS__GET_FLAGS } from '@/store/types';

import * as address from './modules/address';
import * as cart from './modules/cart';
import * as loading from './modules/loading';
import * as modals from './modules/modals';
import billingInformation from './modules/billing-information';
import { contactInfo } from './modules/contact-info';
import { customerLeads } from './modules/customer-leads';
import deal from './modules/deal';
import error from './modules/error';
import { featureFlags } from './modules/feature-flags';
import getPricing from './modules/get-pricing';
import manualRequest from './modules/manual-request';
import { order } from './modules/order';
import { orderServiceLead } from './modules/order-service-lead';
import otherServices from './modules/other-services';
import screenSize from './modules/screen-size';
import { turnstile } from './modules/turnstile';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    modules: {
        address,
        billingInformation,
        cart,
        contactInfo,
        customerLeads,
        deal,
        error,
        featureFlags,
        getPricing,
        loading,
        manualRequest,
        modals,
        order,
        orderServiceLead,
        otherServices,
        screenSize,
        turnstile,
    },
});

store.dispatch(FEATURE_FLAGS__GET_FLAGS);

export default store;
